import React, { VoidFunctionComponent } from 'react'

import { ReactComponent as AccessabilityIcon } from 'images/accesability.svg'

import styles from './UserWayTrigger.module.scss'

export const UserWayTrigger: VoidFunctionComponent = () => {
  const onClick = () => {
    const userWay = document.querySelector<HTMLElement>('#userwayAccessibilityIcon')
    if (userWay) {
      userWay.focus()
      userWay.dispatchEvent(
        new KeyboardEvent('keydown', {
          bubbles: true,
          cancelable: true,
          key: 'Enter',
          code: 'Enter',
          keyCode: 13,
        }),
      )
    }
  }

  return (
    <button onClick={onClick} className={styles.button}>
      <AccessabilityIcon />
    </button>
  )
}
